import { render, staticRenderFns } from "./AddEditPrizeDraw.vue?vue&type=template&id=3e834f38"
import script from "./AddEditPrizeDraw.vue?vue&type=script&lang=js"
export * from "./AddEditPrizeDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports